import { render, staticRenderFns } from "./LeaveWord.vue?vue&type=template&id=45df78fd&scoped=true&"
import script from "./LeaveWord.vue?vue&type=script&lang=js&"
export * from "./LeaveWord.vue?vue&type=script&lang=js&"
import style0 from "./LeaveWord.vue?vue&type=style&index=0&id=45df78fd&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45df78fd",
  null
  
)

export default component.exports